import ScrollReveal from './ScrollReveal';

export default ScrollReveal;
